export default __webpack_public_path__ + "static/media/CellFree.0723efbb.pdf";